class AbortControllerManager {
  private controller: AbortController | null = null;

  getSignal(): AbortSignal {
    // Create a new controller if none exists or if the previous one was aborted
    if (!this.controller || this.controller.signal.aborted) {
      this.controller = new AbortController();
    }
    return this.controller.signal;
  }

  abort() {
    if (this.controller) {
      this.controller.abort();
      this.controller = null;
    }
  }

  reset() {
    this.controller = new AbortController();
  }
}

export const abortControllerManager = new AbortControllerManager();
